/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AmountDecimalValidationError,
  AmountDecimalValidationError$inboundSchema,
  AmountDecimalValidationError$Outbound,
  AmountDecimalValidationError$outboundSchema,
} from "./amountdecimalvalidationerror.js";
import {
  CreatePaymentLinkLineItemOptionValidationError,
  CreatePaymentLinkLineItemOptionValidationError$inboundSchema,
  CreatePaymentLinkLineItemOptionValidationError$Outbound,
  CreatePaymentLinkLineItemOptionValidationError$outboundSchema,
} from "./createpaymentlinklineitemoptionvalidationerror.js";

export type CreatePaymentLinkLineItemValidationError = {
  productID?: string | undefined;
  name?: string | undefined;
  basePrice?: AmountDecimalValidationError | undefined;
  options?:
    | { [k: string]: CreatePaymentLinkLineItemOptionValidationError }
    | undefined;
  quantity?: string | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItemValidationError$inboundSchema: z.ZodType<
  CreatePaymentLinkLineItemValidationError,
  z.ZodTypeDef,
  unknown
> = z.object({
  productID: z.string().optional(),
  name: z.string().optional(),
  basePrice: AmountDecimalValidationError$inboundSchema.optional(),
  options: z.record(
    CreatePaymentLinkLineItemOptionValidationError$inboundSchema,
  ).optional(),
  quantity: z.string().optional(),
});
/** @internal */
export type CreatePaymentLinkLineItemValidationError$Outbound = {
  productID?: string | undefined;
  name?: string | undefined;
  basePrice?: AmountDecimalValidationError$Outbound | undefined;
  options?: {
    [k: string]: CreatePaymentLinkLineItemOptionValidationError$Outbound;
  } | undefined;
  quantity?: string | undefined;
};

/** @internal */
export const CreatePaymentLinkLineItemValidationError$outboundSchema: z.ZodType<
  CreatePaymentLinkLineItemValidationError$Outbound,
  z.ZodTypeDef,
  CreatePaymentLinkLineItemValidationError
> = z.object({
  productID: z.string().optional(),
  name: z.string().optional(),
  basePrice: AmountDecimalValidationError$outboundSchema.optional(),
  options: z.record(
    CreatePaymentLinkLineItemOptionValidationError$outboundSchema,
  ).optional(),
  quantity: z.string().optional(),
});

export function createPaymentLinkLineItemValidationErrorToJSON(
  createPaymentLinkLineItemValidationError:
    CreatePaymentLinkLineItemValidationError,
): string {
  return JSON.stringify(
    CreatePaymentLinkLineItemValidationError$outboundSchema.parse(
      createPaymentLinkLineItemValidationError,
    ),
  );
}
export function createPaymentLinkLineItemValidationErrorFromJSON(
  jsonString: string,
): SafeParseResult<
  CreatePaymentLinkLineItemValidationError,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      CreatePaymentLinkLineItemValidationError$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'CreatePaymentLinkLineItemValidationError' from JSON`,
  );
}
